import { gql } from '@grandvisionhq/graphql';

const cartValidationErrors = gql`
  fragment CartValidationErrorsFragment on CartValidationErrors {
    cartErrors {
      defaultMessage
      validationCode
      passed
    }
    cartLineItemErrors {
      errors {
        defaultMessage
        validationCode

        passed
        ... on SolvableValidationError {
          isSolvable
          actionItem {
            lineItemId
            actioneeSKU
            action
          }
        }
      }
      itemId
    }
  }
`;

export { cartValidationErrors };
//# sourceMappingURL=cart-validation-errors.js.map
